// removed by extract-text-webpack-plugin
module.exports = {"Hero":"Hero__Hero___3SbxE","HeroInside":"Hero__HeroInside___23jsD","HeroContent":"Hero__HeroContent___1Tbx2","Bottom":"Hero__Bottom___2IL3J","ColumnIn":"Hero__ColumnIn___324Yz","ZoomZoom":"Hero__ZoomZoom___3M7JM","Center":"Hero__Center___A44FB","Slug":"Hero__Slug___36xUr"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Hero/Hero.less
// module id = 1151
// module chunks = 0 1